import { InjectionToken } from '@angular/core';
export const LIBRARY_CONFIG = new InjectionToken('Library_Config');
